import faq from '@americanexpress/iguazu-resources/faq';
import eligibility from './eligibility';
import traveler from './traveler';
import benefits from './benefits';
import tlsCredit from './tlsCredit';
import unusedCredit from './unusedCredit';
import hotelMerchOffers from './hotelMerchOffers';
import hotelShopOffers from './hotelShopOffers';
import oneCMSInternetContent from './oneCMSInternetContent';
import smartFill from './smartFill';
import content from './content';
import airlines from './airlines';

export default {
  faq,
  content,
  eligibility,
  traveler,
  benefits,
  tlsCredit,
  unusedCredit,
  hotelMerchOffers,
  hotelShopOffers,
  oneCMSInternetContent,
  smartFill,
  airlines,
};
